<script>
//Components
const Hero = () => import("@/components/media/Hero.vue");

export default {
  name: "programa",
  data() {
    return {};
  },
  head() {
    return this.$head({
      title: "Programas",
    });
  },
  components: {
    Hero,
  },
  computed: {},
};
</script>

<template>
  <section class="program">
    <Hero
      title=""
      :image="'banner-programas.png'"
      height="75vh"
      :search="false"
    />
    <div class="container">
      <header>
        <h1 class="title">PROGRAMAS</h1>
        <p>
          Você sabia que nós, do Grupo Travelex Confidence, fomos reconhecidos
          pelos nossos colaboradores como um excelente lugar para trabalhar e
          recebemos a certificação Great Place to Work por dois anos
          consecutivos, em 2020 e 2021? O selo comprova nosso foco em gestão de
          pessoas e como nos esforçamos para criar uma cultura que se importa
          com seus colaboradores, proporcionando um ambiente acolhedor,
          inspirador e que incentiva o desenvolvimento. Para tornar esse desejo
          realidade, contamos com uma variedade de programas. Conheça-os aqui:
        </p>
      </header>
    </div>
    <div class="talents">
      <div class="container">
        <h2 class="text-cyan-ml">Programa de Jovens Talentos</h2>
        <p>
          <strong>
            Você se recorda do momento em que iniciou no
            mercado de trabalho? <br>E do seu primeiro gestor?
          </strong>
        </p>
        <p>
          Nosso Programa de Jovens Talentos trata-se da junção de duas
          iniciativas incríveis do Grupo Travelex Confidence: Programa de
          Aprendizagem e Programa de Estágio. Ambos surgiram com o objetivo de
          trazer maior visibilidade para estes jovens profissionais que se
          encontram em momentos diferentes da vida, mas que possuem em comum: o
          desejo de fazer a diferença e imergir no seu emprego dos sonhos. Aqui,
          no Grupo Travelex Confidence, todos os dias criamos um ambiente
          propício para o desenvolvimento profissional e intelectual dos
          profissionais do amanhã.
        </p>
      </div>
    </div>
    <div class="personas">
      <div class="container">
        <div class="row d-flex align-items-center justify-content-center">
          <div class="col-lg-3">
               <span class="text-cyan-ml text-lg-left text-center ml-0 p-0 not d-lg-none d-block p-0 m-0">
              Só quem viveu sabe…
            </span>
            <div class="image text-lg-left text-center">
              <img src="@/assets/images/confidence/darlan.png" alt="" />
            </div>
          </div>
          <div class="col-lg-6">
            <span class="text-cyan-ml text-lg-left text-center ml-5 not d-lg-block d-none">
              Só quem viveu sabe…
            </span>
            <p class="text-lg-left text-center mt-4 mt-lg-0">
              “<strong>Comecei como Aprendiz,</strong> fui promovido a
              Assistente Administrativo, depois, Assistente de Operações
              Logísticas, Analista de Bank Notes (Tesouraria Banco) e hoje sou
              <strong>Analista Comercial (Varejo).</strong> <br />
              Antes, eu atuava como auto elétrico automotivo, trabalhava com a
              parte elétrica de carros para pagar o curso de Administração que
              eu fazia na época. A oportunidade como Jovem Aprendiz me abriu
              diversas portas para o mundo profissional, as que eu já desejava e
              as que eu nem imaginava que amaria tanto conhecer.” <br />
              <strong
                >Darlan dos Santos Souza – Iniciou como Aprendiz no Financeiro e
                hoje é Analista Comercial</strong
              >
            </p>
          </div>
        </div>
        <div class="row d-flex align-items-center justify-content-center mt-5">
          <div class="col-lg-6 order-2">
            <span class="text-cyan-ml text-lg-left text-center ml-5 d-lg-block d-none">
              De aprendiz para estagiária e de estagiária para efetivada.
            </span>
            <p class="text-lg-right text-center mt-4 mt-lg-0">
              “A Confidence Corretora de Câmbio foi o meu primeiro trabalho,
              cheguei aqui uma menina tímida e fui surpreendida com o universo
              executivo. Não consigo definir o tanto que aprendi que agregou
              para meu amadurecimento pessoal e profissional. E o que me deixa
              mais feliz é que em cada etapa pude contar com pessoas
              maravilhosas para me apoiar e orientar. Estou muito feliz pela
              efetivação e também muito grata por todos meus líderes e pessoas
              da empresa que foram essenciais para o meu desenvolvimento.”
              <br />
              <strong
                >Samara de Almeida Oliveira - Analista de Contabilidade
                Jr.</strong
              >
            </p>
          </div>
          <div class="col-lg-3 order-1 order-lg-2">
                <span class="text-cyan-ml text-lg-left text-center m-0 p-0 d-lg-none d-block">
              De aprendiz para estagiária e de estagiária para efetivada.
            </span>
            <div class="image text-lg-right text-center">
              <img src="@/assets/images/confidence/samara.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.personas {
  padding: 3rem 0px 10rem 0px;
  background-color: #f8f8f8;
    @include media-breakpoint-down(lg) {
          padding: 0rem 0px 3rem 0px;
      }
  p {
    padding: 0px;
    margin: 0px;
    color: #000;
    margin: 0 auto;
    text-align: center;
  }
  span {
    margin-bottom: 3rem;
    display: block;
    font-size: 1.3rem;

    &:not(.not) {
      margin-top: 3rem;
    }
  }

  .image {
    img {
      max-width: 200px;
      margin-top: 3rem;
    }
  }
}
.talents {
  background-color: #f8f8f8;
  margin-top: 3rem;
  padding: 3rem 0px;
  h2 {
    text-align: center;
  }
  p {
    max-width: 800px;
    color: #000;
    margin: 0 auto;
    text-align: left;
    strong {
      font-size: 1.5rem;
      line-height: calc(1.5rem * 1.5);
      margin-top: 1rem;
      margin-bottom: 2rem;
      display: block;
      font-weight: 500;
    }
  }
}
p {
  font-family: "Lato", sans-serif;
  font-size: 1.1rem;
  line-height: calc(1.1rem * 1.7);
  margin-top: 3rem;
}
</style>

